import "./index.css";
import React from "react";
import Dropdown from "../../../../../../components/Dropdown";
import { PaymentFrequencyOptions } from "../PaymentFrequencyInput/constants";

export default function PaymentFrequencyInput({
  hex,
  white,
  onPaymentFrequencyChange,
  value,
}) {
  return (
    <div className="price-frequency">
      <label
        className="price-frequency__label"
        htmlFor="product-price-frequency"
      >
        Unit of pricing
      </label>
      <Dropdown
        onClick={onPaymentFrequencyChange}
        options={PaymentFrequencyOptions}
        value={PaymentFrequencyOptions.find((option) => option.value === value)}
        hex={hex}
        white={white}
        id="product-price-frequency"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/PaymentFrequencyInput/index.js